import axios from '@/api/axios'

const changeFeedbackTrainersStatus = (feedbackId, date) => {
  return axios.put(`/reviews/${feedbackId}/status`, date)
}

const getFeedbackTrainersList = (params) => {
  return axios.get('/reviews/listForAdmin', {params})
}

const getFeedbackTrainersInfo = (id) => {
  return axios.get(`/reviews/${id}`)
}

export default {
  changeFeedbackTrainersStatus,
  getFeedbackTrainersList,
  getFeedbackTrainersInfo,
}
